import React from 'react';
import designTokens from '@/design-tokens';

interface TruckProps {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const Truck: React.FC<TruckProps> = ({
  size = designTokens['icon/size/default'] || 24,
  color = designTokens['icon/primary'] || '#343A40',
  strokeWidth = 1.5,
  className,
  style
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M8 17.5C8 18.6046 7.10455 19.5 6 19.5C4.89543 19.5 4 18.6046 4 17.5M8 17.5C8 16.3954 7.10455 15.5 6 15.5C4.89543 15.5 4 16.3954 4 17.5M8 17.5H15.5M4 17.5H1V5.5H15.5V17.5M15.5 17.5C15.5 16.3954 16.3954 15.5 17.5 15.5C18.6046 15.5 19.5 16.3954 19.5 17.5C19.5 18.6046 18.6046 19.5 17.5 19.5C16.3954 19.5 15.5 18.6046 15.5 17.5ZM15.5 17.5V9H19.7857L23 13.25V17.5H19.9056"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Truck;
